<template>
    <v-app>
      <audio id="intro_sound" autoplay>
          <source :src="require('@/assets/audio/intro.mp3')">
      </audio>
      <online-watcher dark/>
      <app-loader :loading="firstLoadingLogin"/>
      <panel-menu v-if="$route.meta.menu" @click:menu="showDrawer = true"></panel-menu>

      <subscription-verifier>
            <global-floating-spinner v-if="$route.meta && $route.meta.globalSpinner"/>
            <back-to-appointment-btn/>
            <background />
            <v-main :class="['main', {'subscription-cancelled': subscriptionWasCancelled, blurred}]">
                <transition name="slide-y">
                    <router-view></router-view>
                </transition>
            </v-main>
            <w-footer v-if="$route.meta.footer"></w-footer>
            <login-dialog :onLoginSuccess="onLoginSuccess"></login-dialog>
      </subscription-verifier>
      <v-snackbar
              class="snack-bar-custom"
              v-model="snackBar"
              :color="snackBarColor"
              top
              right
              :timeout="6000"
      >
          {{ snackBarText }}
        <template v-slot:action="{ attrs }">
          <v-btn
              color="white"
              text
              @click="hideSnackBar"
          >
            Cerrar
          </v-btn>
        </template>

      </v-snackbar>
      <loading-spinner></loading-spinner>
    </v-app>

</template>

<script>
    import PanelMenu from '@/components/common/panel/PanelMenu'
    import WFooter from '@/components/common/WFooter'
    import LoadingSpinner from '@/components/common/LoadingSpinner'
    import LoginDialog from '@/components/common/LoginDialog.vue'

    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {initLaravelEcho} from '@/utils/Sockets'
    import colors from 'vuetify/es5/util/colors'
    import GlobalFloatingSpinner from "@/components/common/GlobalFloatingSpinner";
    import BackToAppointmentBtn from "@/components/common/BackToAppointmentBtn";
    import AppLoader from "@/components/common/AppLoader";
    import SubscriptionVerifier from "@/components/common/SubscriptionVerifier";
    import OnlineWatcher from "./components/common/OnlineWatcher";
    import Background from "@/components/common/backgrounds/Background.vue";

    const host = process.env.VUE_APP_SOCKETS_SERVER
    var jwt = ApiUtils.getJWT()
    initLaravelEcho(host, jwt && jwt.access_token || '')

    export default {
        name: 'App',
        components: {
          Background,
          OnlineWatcher,
            SubscriptionVerifier,
            AppLoader,
            BackToAppointmentBtn,
            GlobalFloatingSpinner,
            PanelMenu,
            WFooter,
            LoginDialog,
            LoadingSpinner,
        },
        async mounted() {
            try {
                var vm = this
                await vm.fetchRegions()
                console.log('fetchMe from App load...')

              if(vm.$route.meta && vm.$route.meta.fetchMe === false) return

              await ApiUtils.fetchMe()
            } catch (error) {
                vm.setCurrentUser(null)
            } finally {
                vm.delayAppLoad()
            }
        },
        created() {
            const vm = this

            vm.setFirstLoginLoading(true)
            vm.$vuetify.theme.primary = '#5f50ea' //'#4180d6'
            vm.$vuetify.theme.secondary = '#44477e'
            vm.$vuetify.theme.accent = colors.pink.base
            vm.$vuetify.theme.error = colors.pink.lighten1

            const darkMode = localStorage.getItem('darkMode') === '1'
            vm.$store.commit('setIsDark', darkMode)
            vm.$vuetify.theme.dark = darkMode
        },
        computed: {
            ...mapGetters(['subscriptionWasCancelled']),
            ...mapState([
                'blurred',
                'snackBarModel',
                'snackBarText',
                'snackBarColor',
                'userDataComplete',
                'institutionDataComplete',
                'firstLoadingLogin'
            ]),
            snackBar: {
                get() {
                    return this.snackBarModel
                },
                set(val) {
                    this.setSnackBarModel(val)
                }
            }
        },
        watch: {
            currentUser(user) {
                var vm = this

                if (!user) {
                    return
                }

                let isUserDataComplete = !vm.currentUser.first_name ||
                    !vm.currentUser.last_names ||
                    !vm.currentUser.email ||
                    !vm.currentUser.dni

                vm.setUserDataComplete(isUserDataComplete)

                let isInstitutionDataComplete = !user ||
                    !vm.currentUser.institution ||
                    !vm.currentUser.institution.name

                vm.setInstitutionDataComplete(isInstitutionDataComplete)

            }
        },
        methods: {
            ...mapMutations([
                'hideSnackBar',
                'setFirstLoginLoading',
                'setSnackBarModel',
                'setUserDataComplete',
                'setCurrentUser',
                'setCurrentProvider',
                'setInstitutionDataComplete',
                'setIsOnline'
            ]),
            ...mapActions(['fetchRegions']),
            delayAppLoad() {
                const vm = this
                setTimeout(function () {
                    vm.setFirstLoginLoading(false)
                }, 1500)
            },
            handleScroll(e) {},
            onLoginSuccess(user) {

            }
        }
    }
</script>


<style>

  .main{
    position: relative;
  }

  .fr-wrapper div:first-child a{
    display: none !important;
  }

    .kim-card.translucent {
        background-color: rgba(255, 255, 255, .8) !important;
    }

    /* width */
    aside::-webkit-scrollbar,
    div::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    /* Track */
    aside::-webkit-scrollbar-track,
    div::-webkit-scrollbar-track {
        background: #6a6a72;
    }

    /* Handle */
    aside::-webkit-scrollbar-thumb,
    div::-webkit-scrollbar-thumb {
        background: #171616;
    }

    /* Handle on hover */
    aside::-webkit-scrollbar-thumb:hover,
    div::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    .v-dialog {
        border-radius: 10px;
    }

    .v-dialog.v-dialog--fullscreen {
        border-radius: 0;
    }

    .application.subscription-cancelled {

    }

  .primary--text{
    color: #fff !important;
  }


  .v-list__tile.v-list__tile--link {
    color: #fff !important;
  }

  .v-list__tile.v-list__tile--link.v-list__tile--active,
  .v-list__tile.v-list__tile--link.v-list__tile--active .v-icon
  {
    color: var(--v-accent-darken1) !important;
  }

  .v-navigation-drawer{
    background-color: var(--v-components-base) !important;
  }

  .v-toolbar{
    background-color: transparent;
  }

  .v-calendar-daily,
  .v-calendar-weekly,
  .v-calendar-monthly{
    background-color: var(--v-components-base) !important;
  }

  .v-sheet,
  .v-stepper,
  .v-picker__body,
  .v-list,
  .v-datatable.v-table,
  .v-data-table,
  .v-expansion-panels,
  .v-expansion-panel-header,
  .v-expansion-panel-content,
  .v-tabs-bar,
  .v-card,
  .v-skeleton-loader .v-skeleton-loader__actions,
  .v-skeleton-loader .v-skeleton-loader__article,
  .v-skeleton-loader .v-skeleton-loader__card-heading,
  .v-skeleton-loader .v-skeleton-loader__card-text,
  .v-skeleton-loader__date-picker,
  .v-skeleton-loader .v-skeleton-loader__list-item,
  .v-skeleton-loader .v-skeleton-loader__list-item-avatar,
  .v-skeleton-loader .v-skeleton-loader__list-item-text,
  .v-skeleton-loader .v-skeleton-loader__list-item-two-line,
  .v-skeleton-loader .v-skeleton-loader__list-item-avatar-two-line,
  .v-skeleton-loader .v-skeleton-loader__list-item-three-line,
  .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line,
  .v-skeleton-loader .v-skeleton-loader__table-heading,
  .v-skeleton-loader .v-skeleton-loader__table-thead,
  .v-skeleton-loader .v-skeleton-loader__table-tbody,
  .v-skeleton-loader .v-skeleton-loader__table-tfoot{
    background-color: var(--v-components-base) !important;
  }


    .application--wrap {
        transform: translateZ(0); /*for older browsers*/
        will-change: transform;
    }

    .application.blurred {
        filter: blur(5px)
    }

    @media screen and (max-width: 959px) {
        .application.blurred {
            filter: none;
            display: none
        }
    }

    .snack-bar-custom {
        font-family: Roboto, sans-serif;
    }
</style>
